<style>
    .bar.top {
        z-index: 2;
    }
</style>

<template>
    <div class="bar_wrapper">
        <div 
            v-if="hasOld" 
            class="bar old" 
            :class="{top: oldPercentage < percentage}" 
            :style="{width: scale(oldPercentage)+'%'}"
            :title="oldPercentage+'%'"
        >
            <div class="graph_date grey text-dark">{{oldDate}}</div>
        </div>
        <div class="bar" 
            :class="'bg-'+color" 
            :style="{width: this.scale(percentage)+'%'}"  
            :title="percentage+'%'"
        >
            <div class="graph_date">{{ date }}</div>
            <div :class="modName+'_graph_round marker'"></div>
            <div class="assessment_type">
                <div class="icon" :class="modName+'_graph'"></div>
                <div class="y_label"><span>{{ title }}</span></div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import objectValues from '../../helpers/object_values.js'

    export default {
        components: {},
        props: {
            assessments: {
                required: true,
                type: Array
            },
            module: {
                required: true,
                type: Object
            },
            surveyCutoffs: {
                required: true,
                type: Object
            }
        },
        data() {
            return {}
        },
        computed: {
            percentage: function () {
                if (this.latestFinished && this.latestFinished.score_data){
                    const ratio = this.latestFinished.score_data.total_points/this.latestFinished.score_data.possible_points
                    return Math.round(ratio * 100)
                }
                return 0
            },
            date: function () {
                if (this.latestFinished) {
                    return moment(this.latestFinished.finalized_at).format('MM/YY')
                }
                return ''
            },
            color: function () {
                return this.module.color
            },
            modName: function () {
                switch (this.module.slug) {
                    case 'child-nutrition':
                        return 'nutrition'
                    case 'breastfeeding-and-infant-feeding':
                        return 'infant'
                    case 'infant-and-child-physical-activity':
                        return 'physical'
                    case 'outdoor-play-and-learning':
                        return 'outdoor'
                    case 'farm-to-e-c-e':
                        return 'farm'
                    case 'oral-health':
                        return 'oral'
                    case 'screen-time':
                        return 'screen'
                    case 'social-emotional':
                        return 'social'
                    default:
                        break;
                }
            },
            title: function () {
                return this.module.name
            },
            hasOld: function () {
                return this.previousFinished;
            },
            oldPercentage: function () {
                if (this.previousFinished && this.previousFinished.score_data) {
                    const ratio = this.previousFinished.score_data.total_points/this.previousFinished.score_data.possible_points
                    return Math.round(ratio * 100)
                }
                return 0
            },
            oldDate: function () {
                if (this.previousFinished) {
                    return moment(this.previousFinished.finalized_at).format('MM/YY')
                }
                return ''
            },
            finishedAssessments: function () {
                return this.assessments.filter(ass => ass.finalized_at !== null);
            },
            latestFinished: function () {
                return this.finishedAssessments.slice(-1)[0]
            },
            previousFinished: function () {
                if (this.finishedAssessments.length > 1) {
                    return this.finishedAssessments[0];
                }
            },
        },
        methods: {
            scale(value) {
                const points = objectValues(this.surveyCutoffs).reverse().map(val => val*100);
                let a  = (33/points[1]);
                let b = 0;
                if (value < points[1]) {
                } else if ( value < points[2]) {
                    a = 33/(points[2]-points[1]);
                    b = 66 - a*points[2];
                } else {
                    a = 33/(100-points[2]);
                    b = 100 - a*100;
                }
                return (value*a + b)
            }

        }
}
</script>